import React from "react";
import Loader from "react-loader-spinner";

export default function TransactionFilesBlock(props) {
  const { tableHeader, subHeader = "" ,data, label, loader} = props;

  return (
    <>
     <Loader className="loader trans-loader files-loader"
      type="ThreeDots"
      color="#9c1d26"
      width={100}
      visible={loader}
      />
      <div className="data-table">
        <h2>{tableHeader}&nbsp;</h2>
        <table style={{ width: "100%" }} cellPadding="4">
          <thead>
            <TableRow label={label[0]} data={data[0] || 0}/>
            <TableRow label={label[1]} data={data[1] || 0}/>
            <TableRow label={label[2]} data={data[2] || 0}/>
            {!!label[3] && <TableRow label={label[3]} data={data[3] || 0}/>}
          </thead>
        </table>
      </div>
    </>
  );
}

const TableRow = ({label,data}) => {
  return (
    <tr style={{ borderBottom: "1px solid #d0d0d0" }}>
      <th>{label}</th>
      <td style={{ textAlign: "right", fontSize: '20px'  }}>{data}</td>
    </tr>
  );
};
